import { React, useState, useEffect } from 'react';
import { bootUser } from '../util';
import { apiCall } from '../apiclient';
import { User } from '../classes/User';
import { Spinner, Form, Card, Row, Col, Button, Table } from 'react-bootstrap';
import CatalogDelete from './CatalogDelete';

export default function UserInfo(props) {
    const [userInfo, setUserInfo] = 
            useState({uuid:'', roles_value:1, data:{}});
    const [displayName, setDisplayName] =
            useState(null);
    const [email, setEmail] =
            useState(null);
    const [djRole, setDjRole] =
            useState(null);
    const [mcRole, setMcRole] =
            useState(null);
    const [phRole, setPhRole] =
            useState(null);
    const [adminRole, setAdminRole] =
            useState(null);
    const [about, setAbout] =
            useState(null);
    const [phone, setPhone] =
            useState(null);

    // console.log("UserInfo() " + JSON.stringify(props));

    useEffect(() => {
        // console.log("in UserInfo.useEffect(): " + JSON.stringify(userInfo));
        if(props.user.uuid === '' || props.user.uuid !== userInfo.uuid) {
            // console.log("UserInfo.useEffect()");
            apiCall("get", `users/${props.user.uuid}`).then(function (u) {
                let userObj = new User(u.users[0]);
                setUserInfo(userObj);
                setDisplayName(userObj.data.display_name);
                setEmail(userObj.data.email);
                if(userObj.data.about !== undefined) {
                    setPhone(userObj.data.phone);
                } else {
                    setPhone('');
                }
                
                if(userObj.data.about !== undefined) {
                    // console.log(`about: ${userObj.data.about}`);
                    setAbout(userObj.data.about);
                } else {
                    // console.log("undefined about")
                    setAbout('');
                }
                setDjRole(userObj.hasRole('dj'));
                setMcRole(userObj.hasRole('emcee'));
                setPhRole(userObj.hasRole('party_host'));
                setAdminRole(userObj.hasRole('admin'));
                

            }).catch(function (ex) {
                console.error("UserInfo.useEffect() caught " + ex);
                console.error("UserInfo.useEffect() exception details: " + JSON.stringify(ex));
                setUserInfo({uuid: null});
            });
        }
        // console.log("UserInfo.useEffect() finishing");
    }, [props.user.uuid]);

    function updateData(ev, itemName, itemState, stateSetter, emptyAction) {
        if (emptyAction === undefined) {
            emptyAction = 'reset'
        }
        if (userInfo.data[itemName] != itemState) {
            let iState = itemState.trim();
            if (iState !== '' || emptyAction === 'update') {
                apiCall("put",
                        `users/${userInfo.uuid}/data`,
                        {data:{[itemName]:iState}})
                    .then((d) => {
                        let uInfo = userInfo;
                        uInfo.data[itemName] = iState;
                        props.updateUser(uInfo);
                    }).catch((e) => {
                        setUserInfo({uuid: null});
                    });
            } else if (emptyAction == 'delete') {
                apiCall("delete",
                        `users/${userInfo.uuid}/data`,
                        {data:[itemName]})
                    .then((d) => {
                        let uInfo = userInfo;
                        delete uInfo.data[itemName];
                        props.updateUser(uInfo);
                    }).catch((e) => {
                        setUserInfo({uuid: null});
                    });
            } else {
                stateSetter(userInfo.data[itemName]);
            }
        }
    }

    function updateRole(ev, roleName, roleState, setRole) {
        // console.log(ev);
        setRole(ev.target.checked);
        if (userInfo.hasRole(roleName) && ! ev.target.checked) {
            // console.log(`Revoking ${roleName} role`);
            apiCall("put", 
                `users/${userInfo.uuid}/roles`,
                {revoke_roles:[roleName]}
            ).then((d) => {
                let uInfo = new User(userInfo);
                uInfo.revokeRole(roleName);
                props.updateUser(uInfo);
                setUserInfo(uInfo);
            }).catch((e) => {
                setUserInfo({uuid: null});
            });
        } else if (! userInfo.hasRole(roleName) && ev.target.checked) {
            // console.log(`Granting ${roleName} role`);
            apiCall("put",
                `users/${userInfo.uuid}/roles`,
                {grant_roles:[roleName]}
                ).then((d) => {
                    let uInfo = new User(userInfo);
                    uInfo.grantRole(roleName);
                    props.updateUser(uInfo);
                    setUserInfo(uInfo);
                }).catch((e) => {
                    setUserInfo({uuid: null});
                });
        }
    }

    try {
        if (userInfo.uuid == null) {
            // console.log("userInfo.uuid is null");
            return(bootUser());
        }
        // console.log(`UserInfo() checking uuid: ${props.user.uuid}`);
        if (userInfo.uuid === '') {
            return(<div>
                <p><center><Spinner animation="border" size="lg" /></center></p>
                </div>
                );
        } else {

            let cardTitle = "Update Your Information Here"
            if(props.title !== undefined) {
                cardTitle = props.title
            }
           return(
               <div class="mx-auto w-50">
                <p></p>
                <Card>
                <Card.Title className="mx-auto">{cardTitle}</Card.Title>
                <Card.Body>
                   <Form>
                       <Form.Group className="mb-3" controlId="displayName">
                        <Form.Label>Your Display Name</Form.Label>
                        <Form.Control type="text" value={displayName}
                                onChange={(evt) => setDisplayName(evt.currentTarget.value)}
                                onBlur={(evt) => updateData(evt, "display_name", displayName, setDisplayName)}/>
                        <Form.Text className="text-muted">Your name as shown to others</Form.Text>
                       </Form.Group>
                       <Form.Group className="mb-3" controlID="emailAddress">
                           <Form.Label>Your E-mail address</Form.Label>
                           <Form.Control type="email" value={email}
                                onChange={(evt) => setEmail(evt.currentTarget.value)}
                                onBlur={(evt) => updateData(evt, "email", email, setEmail)} />
                           <Form.Text className="text-muted">Enter your e-mail address</Form.Text>
                       </Form.Group>
                       <Form.Group className="mb-3" controlID="phoneNumber">
                           <Form.Label>Your Phone Number</Form.Label>
                           <Form.Control type="text" value={phone}
                                onChange={(evt) => setPhone(evt.currentTarget.value)}
                                onBlur={(evt) => updateData(evt, "phone", phone, setPhone, 'delete')} />
                           <Form.Text className="text-muted">Optional to share</Form.Text>
                       </Form.Group>
                       <Form.Group as={Row} className="mb-3" controlID="roles">
                           <Form.Label as="legend" column sm={2}>Features</Form.Label>
                           <Col sm={10}>
                               {(props.adminAccess) && 
                               <Form.Check label="Admin" checked={adminRole}
                                    onChange={(evt) => updateRole(evt, "admin", adminRole, setAdminRole)} />
                               }
                               <Form.Check label="D.J." checked={djRole}
                                    onChange={(evt) => updateRole(evt, "dj", djRole, setDjRole)}/>
                               <Form.Check label="M.C." checked={mcRole}
                                    onChange={(evt) => updateRole(evt, "emcee", mcRole, setMcRole)}/>
                               <Form.Check label="Party Host" checked={phRole}
                                    onChange={(evt) => updateRole(evt, "party_host", phRole, setPhRole)}/>
                               <Form.Text className="text-muted">Check the above to enable and disable features.  
                               DJs can upload song catalogs and manage song lists, MCs can create and manage party
                               events, and Party Hosts can collaborate with MCs</Form.Text>
                           </Col>
                       </Form.Group>
                       <Form.Group className="mb-3" controlID={props.user.uuid}>
                           <Form.Label>About You</Form.Label>
                           {(djRole || mcRole) && 
                           <Form.Control as="textarea" rows={4} value={about}
                                onChange={(evt) => setAbout(evt.currentTarget.value)}
                                onBlur={(evt) => updateData(evt, "about", about, setAbout, 'delete')} />
                           }
                           {(!djRole && ! mcRole) &&
                           <Form.Control as="textarea" rows={4} value={about} disabled readOnly />
                           }
                            <Form.Text className="text-muted">This information will be shared with people
                            when they search or browse for DJs and/or MCs.</Form.Text>
                       </Form.Group>
                   </Form>
                </Card.Body>
                {(props.hasSubmit !== undefined && props.hasSubmit) &&
                <Button className="mx-auto mb-3" variant="primary" 
                        onClick={() => props.submitHandler(userInfo)}>Done</Button>
                }
                </Card>
                <CatalogDelete user={userInfo} />
                <p class="pt-0 my-0 text-muted xs">Internal ID: {userInfo.uuid}</p>
                <p class="pt-0 my-0 text-muted xs">Logon User: {userInfo.name}</p>
                </div>
           )
        }
    } catch (err) {
        console.log(err);
        console.log("UserInfo() caught " + JSON.stringify(err));
        return(bootUser());
    }
}